module.exports = __webpack_public_path__ + "media/images/arrow_light_right-61050b187f81f1afde424b0884f5f587.svg";